import React, { useState } from "react";
import axios from "axios";

const CreateUser = () => {
  const [formData, setFormData] = useState({
    imie: "",
    nazwisko: "",
    haslo: "",
    urodziny: "",
    email: "",
    telefon: "",
    notatka: "",
    aktywny: true,
  });
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const generateRandomPassword = (length = 8) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Generate a random password
    const generatedPassword = generateRandomPassword();

    // Include the generated password in the form data
    const userData = {
      ...formData,
      haslo: generatedPassword, // Use the generated password
    };

    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/user/createUser`,
        userData,
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );
      setSuccess(
        "User  created successfully! The password has been sent to the email."
      );
      setFormData({
        imie: "",
        nazwisko: "",
        haslo: "",
        urodziny: "",
        email: "",
        telefon: "",
        notatka: "",
      });
      alert("Uzytkownik został pomyślnie dodany");
    } catch (err) {
      setError(
        "Error creating user: " + (err.response?.data?.message || err.message)
      );
    }
  };

  // ... existing code ...

  return (
    <div className="max-w-2xl mx-auto my-4 p-4 bg-white rounded-lg shadow-lg max-h-[90vh] overflow-auto">
      <h2 className="text-xl font-bold mb-4 text-center text-gray-800">
        Dodaj nowego użytkownika
      </h2>
      {/* Nowy komunikat zwrotny po udanym stworzeniu użytkownika */}
      {success && (
        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-green-600 text-sm">
            Użytkownik został pomyślnie stworzony!
          </p>
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Dane osobowe */}
        <fieldset className="border rounded-lg p-4">
          <legend className="text-base font-semibold px-2 text-gray-700">
            Dane osobowe
          </legend>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Imię
              </label>
              <input
                type="text"
                name="imie"
                value={formData.imie}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nazwisko
              </label>
              <input
                type="text"
                name="nazwisko"
                value={formData.nazwisko}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Data urodzenia
            </label>
            <input
              type="date"
              name="urodziny"
              value={formData.urodziny}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </fieldset>

        {/* Dane kontaktowe */}
        <fieldset className="border rounded-lg p-4">
          <legend className="text-base font-semibold px-2 text-gray-700">
            Dane kontaktowe
          </legend>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Telefon
              </label>
              <input
                type="tel"
                name="telefon"
                value={formData.telefon}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>
        </fieldset>

        {/* Dodatkowe informacje */}
        <fieldset className="border rounded-lg p-4">
          <legend className="text-base font-semibold px-2 text-gray-700">
            Dodatkowe informacje
          </legend>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notatka
            </label>
            <textarea
              name="notatka"
              value={formData.notatka}
              onChange={handleChange}
              rows="2"
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Dodatkowe informacje..."
            />
          </div>
        </fieldset>

        {/* Przyciski i komunikaty */}
        <div className="mt-4">
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Utwórz użytkownika
          </button>
        </div>

        {error && (
          <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        )}

        {success && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-600 text-sm">{success}</p>
          </div>
        )}
      </form>
    </div>
  );

  // ... existing code ...
};

export default CreateUser;
